import { SET_ERROR, CLEAR_ERROR } from '../actions/actionTypes';
import { ErrorAction } from '../actions/error';

export type ErrorReducer = {
    code: string;
    title: string;
    description: string;
    image: string;
    onClose?: () => void;
};

const intialState: ErrorReducer = {
    code: '',
    title: '',
    description: '',
    image: '',
    onClose: undefined,
};

const error = (state = intialState, action: ErrorAction): ErrorReducer => {
    switch (action.type) {
        case SET_ERROR:
            return action.payload as ErrorReducer;
        case CLEAR_ERROR:
            return intialState;
        default:
            return state;
    }
};

export default error;
